<template>
  <svg class="order-zero" width="30.1" height="25.53" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.1 25.53"><path d="M20.32 10.44c-2.2 1-9.68 2.08-8.29-2.71C14.18.33 2.77-3.38.6 4.06a15 15 0 0 0 6.16 16.79c5.74 3.78 13 3.12 18.92.33 7-3.28 1.63-14-5.36-10.74z" fill="#fff"/></svg>
</template>

<script>
export default {
  name: 'OrderZero'
}
</script>

<style lang="scss" scoped>
.order-zero {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  animation: 1.55s bounce both;
  transform-origin: center bottom;
}
</style>
